import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "value", "valueChange", "label", "onChange", "defaultValue", "error", "errMessage", "hideClearButton", "formTitleDirection", "formTitle", "formTitleClassName", "formTitleSlot"],
    _excluded2 = ["name", "control", "rules", "defaultValue", "containerClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useState } from 'react';
import { Box, Typography, styled } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import clsx from 'clsx';
import dayjs, { isDayjs } from 'dayjs';
import 'dayjs/locale/en-gb';
import { useController } from 'react-hook-form';
import { JoveFormErrorInfoView } from '../form/JoveFormErrorInfoView';
import { JoveFormTitleDirectionEnum } from '../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var StyleDatePicker = styled(DatePicker)({
  '& input:focus': {
    'box-shadow': 'none'
  }
});
var JoveDatePicker = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      value = props.value,
      valueChange = props.valueChange,
      label = props.label,
      onChange = props.onChange,
      defaultValue = props.defaultValue,
      error = props.error,
      errMessage = props.errMessage,
      hideClearButton = props.hideClearButton,
      _props$formTitleDirec = props.formTitleDirection,
      formTitleDirection = _props$formTitleDirec === void 0 ? JoveFormTitleDirectionEnum.top : _props$formTitleDirec,
      formTitle = props.formTitle,
      formTitleClassName = props.formTitleClassName,
      formTitleSlot = props.formTitleSlot,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(defaultValue),
      selectDate = _useState[0],
      setSelectDate = _useState[1];

  var dateChangeAction = function dateChangeAction(value) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    setSelectDate(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  return /*#__PURE__*/_jsx(LocalizationProvider, {
    dateAdapter: AdapterDayjs,
    adapterLocale: "en-gb",
    children: /*#__PURE__*/_jsxs(Box, {
      className: clsx('flex flex-col', className),
      children: [formTitleDirection === JoveFormTitleDirectionEnum.top && (formTitleSlot ? formTitleSlot : formTitle ? /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle2",
        className: clsx('mb-1 font-bold', formTitleClassName),
        children: formTitle
      }) : null), /*#__PURE__*/_jsxs(Box, {
        className: "flex w-full flex-row items-center space-x-2",
        children: [formTitleDirection === JoveFormTitleDirectionEnum.left && (formTitleSlot ? formTitleSlot : formTitle ? /*#__PURE__*/_jsx(Typography, {
          variant: "subtitle2",
          className: clsx('font-bold', formTitleClassName),
          children: formTitle
        }) : null), /*#__PURE__*/_jsxs(Box, {
          className: "flex w-0 flex-1 flex-col",
          children: [/*#__PURE__*/_jsx(StyleDatePicker, _objectSpread(_objectSpread({}, rest), {}, {
            ref: ref,
            label: label,
            value: value === undefined ? selectDate : isDayjs(value) ? value : !!value ? dayjs(value) : null,
            defaultValue: defaultValue,
            onChange: dateChangeAction,
            slotProps: {
              textField: {
                size: (rest === null || rest === void 0 ? void 0 : rest.size) || 'medium'
              },
              field: {
                clearable: !hideClearButton,
                onClear: function onClear() {
                  dateChangeAction(null);
                }
              }
            }
          })), /*#__PURE__*/_jsx(JoveFormErrorInfoView, {
            error: error,
            errMessage: errMessage
          })]
        })]
      })]
    })
  });
});
export var JoveDatePickerControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      containerClassName = props.containerClassName,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JoveDatePicker, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      defaultValue: defaultValue,
      onChange: onChange,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveDatePicker;